import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function FullAccessBanner() {
  const { user } = useAuth();
  const key = `sb_full_access_seen_${user?.id}`;
  const [hidden, setHidden] = useState(() => !!localStorage.getItem(key));
  const recent = user?.full_access_at && Date.now() - new Date(user.full_access_at).getTime() < 14 * 864e5;
  if (!recent || hidden) return null;
  const close = () => { localStorage.setItem(key, "1"); setHidden(true); };
  return (
    <div className="mb-5 rounded-2xl bg-[#E8F8F4] border border-[#1DB99A]/40 p-4 flex items-start gap-3" data-testid="full-access-banner">
      <CheckCircle2 className="h-6 w-6 text-[#1DB99A] shrink-0" />
      <div className="flex-1"><div className="font-bold text-[#1E2B3C]">Full Access Activated</div><p className="text-sm text-[#5C6B73]">All business ideas are now unlocked. <Link to="/ideas" className="font-semibold text-[#179B80] underline" data-testid="full-access-browse-link">Browse and search all ideas</Link></p></div>
      <button onClick={close} aria-label="Close" className="h-8 w-8 flex items-center justify-center text-[#8C9BA5]" data-testid="full-access-banner-close"><X className="h-4 w-4" /></button>
    </div>
  );
}
